<template>
  <div class="lmenuw" :class="mustatus">
    <div class="lmutit">
      <div class="lmutxt" v-if="mustatus=='normal'">导航菜单</div>
      <div class="lmubtn" @click="slider_menu">
        <el-icon size="16" color="#ffffff">
          <d-arrow-left v-if="mustatus=='normal'" />
          <d-arrow-right v-else />
        </el-icon>
      </div>
    </div>
    <div class="lmulis">
      <a href="javascript:void(0)" :class="['menu-a',defsel?'sel':'']" @click="OpenDef()">
        <img :src="require('@/assets/images/leftnav/001'+(defsel?'_sel':'')+'.png')" />管理首页
      </a>
    </div>
    <div class="lmulis" v-for="(item,key) in data" :key="key">
      <a href="javascript:void(0)" :class="['menu-a',item.child.length?'has-more':'',item.sel?'sel':'']" @click="OpenMenu(1,key)">
        <img :src="require('@/'+item.icon+(item.sel?'_sel':'')+'.png')" />{{item.name}}
      </a>
      <div :class="['menu-lower',item.sel?'show':'']" v-if="item.child">
        <div class="menu-b" v-for="(d,k) in item.child" :key="k">
          <a href="javascript:void(0)" :class="['b-this',d.child.length?'has-more':'',d.sel?'sel':'']" @click="OpenMenu(2,key,k)">{{d.name}}</a>
          <div :class="['menu-lower',d.sel?'show':'']" v-if="d.child.length">
            <a href="javascript:void(0)" v-for="(e,ek) in d.child" :class="['menu-c',e.sel?'sel':'']" :key="ek" @click="OpenMenu(3,key,k,ek)">{{e.name}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftMenu',
  data(){
    return {
      mustatus:'normal',
      data:[],
      defsel:true
    }
  },
  created() {
    this.getMenu();
  },
  methods:{
    /**
     * 获取菜单
     */
    getMenu:function (){
      var _this=this;
      this.RequestApi('getmenu.html').then(function (res){
        if(res.status==1){
          _this.data=res.data;
          _this.$store.commit('UpAdmin',res.admin);
        }
      })
    },
    /**
     * 左侧菜单收缩、展开
     */
    slider_menu:function (){
      this.mustatus=this.mustatus=='normal'?'small':'normal';
    },
    /**
     * 点击管理首页
     */
    OpenDef:function (){
      this.defsel=true;
      for(let item of this.data){
        item.sel=false;
        for (let d of item.child){
          d.sel=false;
          for (let e of d.child){
            e.sel=false;
          }
        }
      }
    },
    /**
     * 点击导航菜单
     */
    OpenMenu:function (type,key1,key2,key3){
      this.defsel=false;
      for(let item of this.data){
        item.sel=false;
        for (let d of item.child){
          d.sel=false;
          for (let e of d.child){
            e.sel=false;
          }
        }
      }
      this.data[key1].sel=true;
      if(type==3){
        this.data[key1].child[key2].sel=true;
        this.data[key1].child[key2].child[key3].sel=true;
        this.OpenUrl(this.data[key1].child[key2].child[key3].route_path);
      }else if(type==2){
        this.data[key1].child[key2].sel=true;
        if(!this.data[key1].child[key2].child.length) this.OpenUrl(this.data[key1].child[key2].route_path);
      }else{
        if(!this.data[key1].child.length) this.OpenUrl(this.data[key1].route_path);
      }
    }
  }
}
</script>
<style scoped lang="less">
.lmenuw{
  width: 160px;
  background: @colorBlack;
  overflow: hidden;
  transition:width 0.1s linear;
  flex-shrink: 0;
  .lmulis{
    padding-left: 5px;
    .menu-a{
      display: block;
      position: relative;
      font-size: @sizeBig;
      line-height: 50px;
      color: @colorWhite;
      text-decoration: none;
      img{display: inline-block; width: 20px; height: 20px; margin:15px 6px 0 0; vertical-align: top;}
      &:hover{
        background: #2d2e34;
      }
      &.has-more:before{
        display: block;
        content:" ";
        width: 12px;
        height: 12px;
        position: absolute;
        right: 10px; top: 19px;
        background: url("../../assets/images/leftnav/arrowdown.png") no-repeat;
        transition:transform 0.3s;
      }
      &.sel{
        color: #409EFF;
        &:before{
          background: url("../../assets/images/leftnav/arrowdown_sel.png") no-repeat;
        }
      }
    }
    .menu-lower{
      display: none;
      &.show{
        display: block;
      }
      .menu-b{
        .b-this{
          display: block;
          position: relative;
          font-size: @sizeNormal;
          line-height: 40px;
          text-indent: 26px;
          color: @colorWhite;
          text-decoration: none;
          &:hover{
            background: #2d2e34;
          }
          &.has-more:before{
            display: block;
            content:" ";
            width: 12px;
            height: 12px;
            position: absolute;
            right: 10px; top: 14px;
            background: url("../../assets/images/leftnav/arrowdown.png") no-repeat;
            transition:transform 0.3s;
          }
          &.sel{
            color: #409EFF;
            &:before{
              background: url("../../assets/images/leftnav/arrowdown_sel.png") no-repeat;
            }
          }
        }
      }
      .menu-c{
        display: block;
        font-size: @sizeSmall;
        line-height: 32px;
        text-indent: 38px;
        color: @colorWhite;
        text-decoration: none;
        &:hover{
          background: #2d2e34;
        }
        &.sel{
          color: #409EFF;
        }
      }
    }
  }
  .lmutit{
    height: 32px;
    padding: 0 5px;
    line-height: 32px;
    background: @colorBlack2;
    user-select: none;
    .lmutxt{
      float: left;
      color: @colorWhite;
      font-size: @sizeNormal;
      letter-spacing:3px;
    }
    .lmubtn{
      float: right;
      cursor: pointer;
    }
  }
}
.small{
  width: 36px;
  transition:width 0.1s linear;
}
</style>
